<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm02_title"></a><a id="page_3"></a><strong>Tell Me What to Eat If I Have Acid Reflux <em>Revised Edition</em></strong></h1>
<p class="bsubtitle"><em>Nutrition You Can Live With</em></p>
<p class="author"><strong>By Elaine Magee, MPH, RD</strong></p>
<p class="author"><strong>Foreword by Anthony A. Starpoli, MD</strong></p>
<p class="images1"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_title.vue?065efcaa